import { z } from 'zod'

export const schema = z.object({
  value_date: z.iso.date(),
})

export type SchemaType = z.infer<typeof schema>
